const headersTitles = [
    "Nro. de Pago",
    "Proyecto Comercial",
    "Producto",
    "Descripción",
    "Tipo de Pago",
    "Origen de Pago",
    "Fecha de pago",
    "Monto de la Cuota($)",
    "Monto Pagado($)",
    "Saldo($)"
];

module.exports = {
    headersTitles
};



// WEBPACK FOOTER //
// ./src/views/MyPayments/MyPaymentsVariables.js